module.exports = __webpack_public_path__ + "fonts/STKBureauSerif-Light.7d6d11a476c844840980d0ec774250b8.ttf";